'use strict';
var app = require('angular').module('directive.chipsTags', []);

app.directive('chipsTags', [require('./chipsTagsDirective')]);
